import { z } from 'zod'

export const publicFeatureFlagItemSchema = z.object({
  module_name: z.string(),
  enabled: z.boolean(),
  metadata: z.record(z.string(), z.unknown()).optional(),
})

export const publicFeatureFlagsResponseSchema = z.object({
  data: z.array(publicFeatureFlagItemSchema),
})

export type PublicFeatureFlagItem = z.infer<typeof publicFeatureFlagItemSchema>
